/**
 * @generated SignedSource<<43a502b88235c3a5f802ec2f9c761857>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { Url } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type EntityProfilePicFragment$data = {
  readonly displayName: string;
  readonly image?: Url | null | undefined;
  readonly imageThumbnail?: Url | null | undefined;
  readonly " $fragmentType": "EntityProfilePicFragment";
};
export type EntityProfilePicFragment$key = {
  readonly " $data"?: EntityProfilePicFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EntityProfilePicFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "thumbnail"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "EntityProfilePicFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "condition": "thumbnail",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageThumbnail",
          "storageKey": null
        }
      ]
    },
    {
      "condition": "thumbnail",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "image",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Entity",
  "abstractKey": "__isEntity"
};

(node as any).hash = "95fa085373c606e4038a07853e8cd9a4";

export default node;
